module.exports = __webpack_public_path__ + "img/pamphlet_thumb03@2x.d777e41a.png";